import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { t } from 'ttag';

import AcceptInvite from 'common/components/Auth/AcceptInvite';
import useSearchParams from 'common/hooks/useSearchParams';

import {
  checkInviteStatus as checkInviteStatusFn,
  acceptInvite as acceptInviteFn,
} from '@domains/Organization/Organizer/service';

export default () => {
  const navigate = useNavigate();
  const query = useSearchParams();
  const token = query?.get('token');
  const email = query?.get('email');
  const organizationId = query?.get('organization_id');
  const [organizationName, setOrganizationName] = useState('');
  const location = useLocation();

  return (
    <AcceptInvite
      token={token}
      id={organizationId}
      description={t`Accept the invitation to gain access to ${organizationName}`}
      checkInviteStatusFn={async () => {
        const status = await checkInviteStatusFn(organizationId, { token });
        setOrganizationName(status.organizationName);
        return status;
      }}
      acceptInviteFn={payload => acceptInviteFn(organizationId, { ...payload, token, email })}
      onAcceptInvite={() => navigate('/organization', { replace: true })}
      onAccept={() => {
        const queryParams = new URLSearchParams(location.search).toString();
        navigate(`/activate?${queryParams}`);
      }}
      onLogin={() => navigate('/login', { replace: true })}
    />
  );
};
